export class FilterUseProducts{
    constructor(
        public collaboratorsId: number[],
        public document: number,
        public dateStart: Date,
        public dateEnd: Date,
        public productsId: number[],
        public groupByMonth: boolean = false
    ){}
}

export class FilterCreditHistory{
    constructor(
        public dateStart: Date,
        public dateEnd: Date,
        public type: string,
        public stauts: string,
        public value: number,
        public purchaseId: number
    ){}
}
export class FilterCard{
    constructor(
        public dateInclusion: Date,
        public pan: string,
        public status: number
    ){}
}

export class FilterCardSolicitation{
    constructor(
        public dateStart: Date,
        public dateEnd: Date,
        public status: number
    ){}
}

export class FilterExpenses {
    constructor(
        public dateStart: Date,
        public dateEnd: Date,
        public collaborator: string
    ){}
}